import { Box, Tabs } from '@mui/material';

import { LocaleContext } from '@/Contexts/LocaleContext';
import { useContext } from 'react';
import { NavTab } from './NavTab';

interface SideNavProps {
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  subValue: number;
  onSubChange: (event: React.SyntheticEvent, newValue: number) => void;
  partnerTerm: string;
  partnerName: string;
  showShippingAddress: boolean;
}

export default function SideNav({
  value,
  onChange,
  subValue,
  onSubChange,
  partnerTerm,
  partnerName,
  showShippingAddress,
}: SideNavProps) {
  const { translatedText } = useContext(LocaleContext);

  return (
    <Box>
      <VerticalNavTabs value={value} onChange={onChange} ariaLabel='My Account Tabs'>
        <NavTab value={0} label={translatedText.myaccount.tabAccountSettings} activeValue={value} />
        <NavTab value={1} label={partnerName} activeValue={value} />
      </VerticalNavTabs>

      {value === 1 && (
        <VerticalNavTabs
          value={subValue}
          onChange={onSubChange}
          ariaLabel='Partner Sub Tabs'
          width='255px'
          marginLeft={2}
        >
          <NavTab
            value={0}
            label={translatedText.myaccount.tabPrimaryContact}
            activeValue={subValue}
          />
          <NavTab
            value={1}
            label={`${partnerTerm} ${translatedText.signup.headerLabel}`}
            activeValue={subValue}
          />
          {showShippingAddress && (
            <NavTab
              value={2}
              label={translatedText.myaccount.tabShippingAddress}
              activeValue={subValue}
            />
          )}
        </VerticalNavTabs>
      )}
    </Box>
  );
}

interface VerticalNavTabsProps {
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  ariaLabel: string;
  width?: string | number;
  marginLeft?: number;
  children: React.ReactNode;
}

function VerticalNavTabs({
  value,
  onChange,
  ariaLabel,
  width = '275px',
  marginLeft,
  children,
}: VerticalNavTabsProps) {
  return (
    <Tabs
      orientation='vertical'
      variant='scrollable'
      value={value}
      onChange={onChange}
      aria-label={ariaLabel}
      slotProps={{
        indicator: {
          sx: {
            left: 0,
            right: 'auto',
          },
        },
      }}
      sx={{
        borderLeft: 1,
        borderColor: 'divider',
        width,
        ...(marginLeft !== undefined ? { ml: marginLeft } : {}),
        '& .MuiTab-root': { alignItems: 'flex-start', textAlign: 'left' },
        '& .MuiTabs-scroller': { height: 'fit-content' },
      }}
    >
      {children}
    </Tabs>
  );
}
